import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { getAccessToken, setAccessToken, removeTokens, refreshAccessToken as refreshTokenUtil } from './auth';

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const initializeAuth = async () => {
            const token = getAccessToken();
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
                    if (decodedToken.exp * 1000 > Date.now()) {
                        setAuth({ token, user: decodedToken });
                    } else {
                        const newToken = await refreshTokenUtil();
                        if (newToken) {
                            const newDecodedToken = jwtDecode(newToken);
                            setAuth({ token: newToken, user: newDecodedToken });
                        } else {
                            removeTokens();
                        }
                    }
                } catch (error) {
                    console.error('Error decoding token', error);
                    removeTokens();
                }
            }
            setLoading(false);
        };

        initializeAuth();
    }, []);

    const login = (token) => {
        setAccessToken(token);
        const decodedToken = jwtDecode(token);
        setAuth({ token, user: decodedToken });
    };

    const logout = () => {
        removeTokens();
        setAuth({});
    };

    const refreshToken = async () => {
        try {
            const newToken = await refreshTokenUtil();
            if (newToken) {
                login(newToken);
                return true;
            }
            return false;
        } catch (error) {
            console.error('Failed to refresh token', error);
            logout();
            return false;
        }
    };

    return (
        <AuthContext.Provider value={{ auth, setAuth, login, logout, refreshToken, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;